import { render, staticRenderFns } from "./DomainSearch.vue?vue&type=template&id=0e33c4b5&"
import script from "./DomainSearch.vue?vue&type=script&lang=js&"
export * from "./DomainSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports